import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  confirmResend(event) {
    const btn = event.currentTarget
    this._pendingBtn = btn
    this._pendingUrl = btn.dataset.url
    const email = btn.dataset.email || ""

    // Remove existing modal if any
    this._removeModal()

    const backdrop = document.createElement("div")
    backdrop.id = "resend-invite-modal"
    backdrop.className = "fixed inset-0 z-50 flex items-center justify-center bg-black/40"
    backdrop.addEventListener("click", (e) => {
      if (e.target === backdrop) this._removeModal()
    })

    backdrop.innerHTML = `
      <div class="bg-white rounded-lg shadow-xl w-full max-w-sm mx-4 p-6" data-action="click->admin--resend-invite#stopPropagation">
        <h3 class="text-base font-semibold text-gray-900 mb-2">Resend Invitation</h3>
        <p class="text-sm text-gray-600 mb-5">Are you sure you want to resend the invitation to <strong>${this._escapeHtml(email)}</strong>?</p>
        <div class="flex justify-end gap-2">
          <button type="button" id="resend-invite-cancel"
                  class="px-3 py-1.5 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md cursor-pointer transition-colors">
            Cancel
          </button>
          <button type="button" id="resend-invite-confirm"
                  class="px-3 py-1.5 text-sm font-medium text-white bg-brand hover:bg-brand-600 rounded-md cursor-pointer transition-colors">
            Resend
          </button>
        </div>
      </div>
    `

    document.body.appendChild(backdrop)

    backdrop.querySelector("#resend-invite-cancel").addEventListener("click", () => this._removeModal())
    backdrop.querySelector("#resend-invite-confirm").addEventListener("click", () => {
      this._removeModal()
      this._resend()
    })
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  async _resend() {
    const btn = this._pendingBtn
    const url = this._pendingUrl
    if (!btn || !url) return

    const originalHTML = btn.innerHTML

    btn.disabled = true
    btn.innerHTML = `<svg class="animate-spin w-3.5 h-3.5 inline-block" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path></svg>`

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
        }
      })

      if (response.ok) {
        btn.innerHTML = `<span class="text-green-600 font-medium">Sent!</span>`
        setTimeout(() => { btn.innerHTML = originalHTML; btn.disabled = false }, 2000)
      } else {
        btn.innerHTML = originalHTML
        btn.disabled = false
      }
    } catch {
      btn.innerHTML = originalHTML
      btn.disabled = false
    }
  }

  _removeModal() {
    document.getElementById("resend-invite-modal")?.remove()
  }

  _escapeHtml(str) {
    const div = document.createElement("div")
    div.textContent = str
    return div.innerHTML
  }
}
